<template>
  <div>
    <label v-if="label" class="form-label">{{ label }}:</label>

    <div class="relative p-0" :class="{ error: error }">
      <input ref="file" type="file" :accept="accept" class="hidden" @change="change" />

      <!-- Button Find File -->
      <div v-if="!upload && !modelValue?.url" class="p-2">
        <button type="button" class="btn-primary font-normal text-xs px-6 py-2.5" @click="browse">
          <font-awesome-icon icon="fa-image-portrait" class="mr-2" /> Procurar
        </button>
      </div>

      <div v-else class="flex items-center justify-center p-2">
        <div class="overflow-hidden">
          <cropper v-if="crop && upload" ref="cropper" :src="photoSelected" @change="changeCrop" />
          <img v-else :src="photoSelected" class="w-52 mx-auto" />
          <div>{{ photoNameSelected }}</div>
          <span class="text-gray-500 text-xs">({{ photoFileSelected }})</span>
        </div>

        <!-- Button to remove or update photo -->
        <button type="button" class="absolute right-0 top-0 py-1 w-[30px] text-center text-white text-sm font-medium bg-red-500 hover:bg-red-700 rounded-sm" @click="remove"><font-awesome-icon icon="fa-xmark" /></button>
        <button type="button" class="absolute right-0 top-10 py-1 w-[30px] text-center text-white text-sm font-medium bg-blue-500 hover:bg-blue-700 rounded-sm" @click="changePhoto"><font-awesome-icon icon="fa-rotate" /></button>
      </div>
    </div>

    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'

import Compressor from 'compressorjs'
import heic2any from 'heic2any'

export default {
  components: {
    Cropper,
  },

  props: {
    modelValue: Object,
    label: String,
    accept: {
      type: String,
      default: 'image/*',
    },
    crop: {
      type: Boolean,
      default: true,
    },
    error: String,
  },
  emits: ['update:modelValue'],

  data() {
    return {
      upload: null,
      preview: null,
    }
  },
  computed: {
    photoSelected: function() {
      if(this.upload) {
        return URL.createObjectURL(this.upload)
      } else if(this.modelValue.url) {
        return this.modelValue.url
      }
      return '#'
    },
    photoNameSelected: function() {
      if(this.upload) {
        return this.upload.name
      } else if(this.modelValue.url) {
        return this.modelValue.name
      }
      return ''
    },
    photoFileSelected: function() {
      if(this.upload) {
        return this.filesize(this.upload.size)
      } else if(this.modelValue.url) {
        return this.filesize(this.modelValue.size)
      }
      return ''
    },
  },
  watch: {
    modelValue(value) {
      if (!value) {
        this.$refs.file.value = ''
      }
    },
  },
  methods: {
    filesize(size) {
      var i = Math.floor(Math.log(size) / Math.log(1024))
      return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i]
    },
    browse() {
      this.$refs.file.click()
    },

    compressAndEmit(file, name, type) {
      new Compressor(file, {
        quality: 0.8,
        mimeType: 'png',

        success: result => {
          const file = new File([result], name, { type })
          this.$emit('update:modelValue', file)
        },

        error: err => console.log( err ),
      } )
    },

    async change(e) {
      let file = e.target.files[0]

      if (file && file.type === 'image/heif') {
        const blob = await heic2any({ blob: file })
        
        file = new File([blob], file.name.replace('.heic', '.png'), {
          type: 'image/png',
        })
      }

      this.upload = file
      this.compressAndEmit(this.upload, this.upload.name, this.upload.type)
    },

    changeCrop() {
      let model = this.modelValue
      const { canvas } = this.$refs.cropper.getResult()

      if (!canvas)
        return

      canvas.toBlob(async blob => this.compressAndEmit(blob, model.name, model.type), 'image/png')
    },
    remove() {
      this.upload = null
      this.$emit('update:modelValue', null)
    },
    changePhoto() {
      this.browse()
    },
  },
}
</script>
